/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_History_TitleInputs */

const en_us2_body_assessment_history_title = /** @type {(inputs: Body_Assessment_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your assessments`)
};

const pt_br2_body_assessment_history_title = /** @type {(inputs: Body_Assessment_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas avaliações`)
};

const es_419_body_assessment_history_title = /** @type {(inputs: Body_Assessment_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus evaluaciones`)
};

const pt_pt2_body_assessment_history_title = /** @type {(inputs: Body_Assessment_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tuas avaliações`)
};

const fr_fr2_body_assessment_history_title = /** @type {(inputs: Body_Assessment_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes évaluations`)
};

const de_de2_body_assessment_history_title = /** @type {(inputs: Body_Assessment_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Messungen`)
};

const it_it2_body_assessment_history_title = /** @type {(inputs: Body_Assessment_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue valutazioni`)
};

/**
* | output |
* | --- |
* | "Your assessments" |
*
* @param {Body_Assessment_History_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_history_title = /** @type {((inputs?: Body_Assessment_History_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_History_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_history_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_history_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_history_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_history_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_history_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_history_title(inputs)
	return en_us2_body_assessment_history_title(inputs)
});
export { body_assessment_history_title as "body-assessment.history_title" }